<template>
  <component
    :is="`block-${sectionBlockLayout}-presentation`"
    :data="data"
    :titleColor="sectionTitleColor"
  >

    <template slot="blockElement" slot-scope="props">

      <v-row
        :no-gutters="noRowGutters"
        align="center"
        justify="center"
      >

        <v-col
          class="sblock"
          :sm="12"
          :lg="12"
          :xl="getCols(props.blockData.type)"
        >

          <component
            :is="isCardOnBlock(props.blockData) ? 'v-card' : 'div'"
            class="mx-auto"
            v-bind="getDecoratorStyles(props.blockData)"
          >
            <!-- if true condition div added instead of v-card-title -->
            <component :is="isCardOnBlock(props.blockData) ? 'v-card-text' : 'div'">

              <component :is="getBlockLayout(props.blockData.type)" :blockType="props.blockData.type">

                <slot name="title">

                  <component
                    v-if="props.blockData.showTitle"
                    is="block-title"
                    :styling="getTiTleStyle(props.blockData)"
                  >
                    {{ props.blockData.title }}
                  </component>

                </slot>

                <slot name="blockInline" :block="props.blockData" />

                <slot name="presentation" :item="props.blockData.settings.fields" :index="props.blockIndex">

                  <component
                    v-if="block[props.blockData.type] || false"
                    :is="componentLoader(getPresentationComponentName(props.blockData))"
                    :sectionId="sectionId"
                    :id="props.blockData.id"
                    :blockIndex="props.blockIndex"
                    :block="props.blockData"
                    :fields="props.blockData.settings.fields"
                    :settings="props.blockData.settings"
                    :theme="theme"
                  />

                </slot>

              </component>
            </component>
          </component>
        </v-col>
      </v-row>
    </template>
  </component>
</template>
<script>
  import * as SectionsConfig from '@fremcast/section/config';
  import * as blocks from '@fremcast/section/blocks';
  import styles from "@fremcast/section/mixins/styles";
  import Vue from 'vue';
  import { VCard, VCardText } from 'vuetify/lib'
  const VIDEO_TYPE = 'Videos';
  const COVER_CATEGORY = 'CoverCategory';
  const HEADER_ZONE = 'header';
  const VIDEO_SINGLE = 'VideoSingle';
  const BODY_ZONE = 'body';
  const PRESENTATION = "videoPresentation";

  export default {
    data() {
      return {
        component: this.theme,
        sections: [],
        displaySectionTitle: true,
        block: blocks.default.data
      };
    },
    props: {
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      theme: String,
      data: Array,
      sectionId: Number,
      sectionZone: String,
      sectionTitleColor: String,
      sectionBackgroundColor: String,
      sectionBlockLayout: {
        type: String,
        default: 'grid'
      },
      forceColumnsFullSize: {
        type: Boolean,
        default: false
      },
      noRowGutters: {
        type: Boolean,
        default: false
      }
    },
    mixins: [
      styles
    ],
    components: {
      BlockTabsPresentation: () => import('./BlockTabsPresentation'),
      BlockGridPresentation: () => import('./BlockGridPresentation'),
      VCard,
      VCardText
    },
    methods: {
      getDecoratorStyles(property) {
         if (this.isCardOnBlock) {
           return this.getCardProps(property);
         }

         return this.getDivProps(property);
      },
      getCardProps(property) {
        //this.sectionBackgroundColor
        const backgroundColor = {
          backgroundColor: property.style.inherit ? 'inherit' : property.backgroundColor
        };

        return {
          style: {...this.getStyleObjectForBlock(property), ...this.getBackgroundColor(backgroundColor)},
          class: this.getBlockStyleObject(property),
          elevation: this.getBoxShadow(property.style),
          shaped: 'shaped' == this.getBoxShape(property.style)
        };
      },
      getDivProps() {
        return {
          //color: property.style.inherit ? this.sectionBackgroundColor : property.backgroundColor,
          style: this.getStyleObjectForBlock(property),
          class: this.getBlockStyleObject(property),
        };
      },
      getCols(type) {
        //Usually required for dev modus
        if (this.forceColumnsFullSize) {
          return 12;
        }

        if (type == VIDEO_TYPE && this.sectionZone == BODY_ZONE) {
          return 12;
        }

        if (type === COVER_CATEGORY) {
          return 12;
        }

        if (this.sectionZone == HEADER_ZONE) {
          return 12;
        }

        if (this.sectionZone == VIDEO_SINGLE) {
          return 12;
        }

        //HTML TYPE
        if (type == 'Html') {
          return 6
        }

        return 9;
      },
      getDescriptionHeader(header) {
        return 'h' + (parseInt(header.substr(header.length - 1)) + 1)
      },
      componentLoader(load) {
        return require(`@fremcast/section/${load}`).default;
      },
      getBlockLayout(type) {
        const blockLayout = (`${type}-layout`).toLowerCase();

        if(blockLayout in Vue.options.components) {
          return blockLayout;
        }

        return 'block-layout';
      },
      getPresentationComponentName(section) {
        const presentation = section.settings.presentation || 'list';
        return this.block[section.type].presentation[presentation];
      },
      getBlockKey(section) {
        return _.has(section.settings, PRESENTATION)
          ? section.settings.videoPresentation
          : section.id;
      },
      getBlockStyleObject(section) {
        let attributes;

        attributes = {
          'paddingTop': (section.style.paddingTop || 4),
          'paddingBottom': (section.style.paddingBottom || 4),
          'paddingLeft': 0, //(section.style.paddingLeft || 4),
          'paddingRight': 0 //(section.style.paddingRight || 4),
        };

        return `pt-${attributes.paddingTop} pb-${attributes.paddingBottom} pl-${attributes.paddingLeft} pr-${attributes.paddingRight}`;
        //return `pt-${attributes.paddingTop} pb-${attributes.paddingBottom} pl-${attributes.paddingLeft} pr-${attributes.paddingRight}`;
      },
      getBoxShadow(style) {
        if ( typeof style.boxShadow === "undefined") {
          return 0
        }

        return style.boxShadow.blurRadius;
      },
      getBoxShape(style) {
        if ( typeof style.boxShadow === "undefined") {
          return 'none';
        }

        return style.boxShadow.shape;
      },
      getTiTleStyle(item) {
        return {
          'flex-direction': 'column',
          'color': item.style.inherit ? this.sectionTitleColor : item.titleColor,
          'justify-content': item.titleAlign,
          'text-align': item.titleAlign
        };
      },
      isCardOnBlock(item) {
        //@Todo: Fix this or always set a card?
        //return true;

        const style = item.style || false;

        if ( typeof style.boxShadow === "undefined") {
          return false
        }

        return style.boxShadow.visible;
      }
    }
  }
</script>

